import { Checkbox, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { Component, useState } from "react";
import { CancelIcon, InfoSecondaryIcon, SucessOutlineIcon } from '../../icon';
import GroupDeletionInfoComponent from '../groups/group-deletion-info.component';
import { appNote, buttonLabels } from "./constants";
import ButtonComponent from "./button/button.component";

interface Props {
	Title?: string;
	Show: boolean;
	onClose: (x: boolean, e?: any) => void;
	Text?: string;
	ButtonName?: string;
	HideCancel?: boolean;
	IsMobileDevice?: boolean;
	Loading?: boolean;
	TextProps?: () => JSX.Element;
	HandleCheckbox?: (x: boolean) => void;
	ShowCheckBox?: boolean;
	CheckBoxText?: string;
	ResponsRecived?: boolean;
	GroupDeletionResponsData?: any;
	DeletedGroupName?: string;
}

const Confirm_Dialog = (props: Props) => {
    const [isChecked, setIsChecked] = useState(false);
    
    const handelchange = (e) => {
        setIsChecked(e.target.checked)
		!!props.HandleCheckbox && props.HandleCheckbox(e.target.checked)
	}

	const handleClose = (e?: any) => {
		props.onClose(false, e);
        setIsChecked(false)
		!!props.HandleCheckbox && props.HandleCheckbox(false)
	}

    return (
        <Dialog
            open={props.Show} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" BackdropProps={props.IsMobileDevice ? {} : { style: { backgroundColor: "transparent" } }}
            classes={{ paper: "br-2 dialogue-shadow" }}>
            <DialogTitle className="p-2" id="alert-dialog-title">
                <div className={`d-flex`}>
                    {props.ResponsRecived && <SucessOutlineIcon />}
                    <span className={"h1-semibold color-display-title"}>
                        {props.Title ? props.Title : "Confirm"}
                    </span>
                    <Tooltip title='Close' placement='bottom'>
                        <CancelIcon className={"c-pointer ml-auto mr-1 my-auto"} onClick={handleClose} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent className='p-2'>
                {!props.ResponsRecived &&
                    <DialogContentText className="h4-regular color-menu-list-font-color" id="alert-dialog-description">
                        {props.TextProps && props.TextProps() || props.Text}
                    </DialogContentText>}
                {props.ShowCheckBox && !props.ResponsRecived &&
                    <div className='d-flex w-break h4-regular'>
                        <Checkbox checked={isChecked}
                            classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                            onChange={handelchange} />
                        <span className='my-auto'>
                            {props.CheckBoxText ? props.CheckBoxText : ""}
                        </span>
                        {!props.IsMobileDevice &&
                            <Tooltip title={<div className='d-flex flex-direction'>
                                <span>{appNote.DELETE_CONTACTS_WITH_GROUP}</span>
                                <span>{appNote.NOTE_DELETE_CONTACTS_WITH_GROUP}</span>
                            </div>} placement="bottom-start" >
                                <InfoSecondaryIcon className='ml-1 my-auto' />
                            </Tooltip>
                        }
                    </div>
                }

                {
                    props.ResponsRecived &&
                    <>
                        <div className='h4-regular'>
                            <span className='h4-semibold'>{props.GroupDeletionResponsData?.deletedContactsCount}/{props.GroupDeletionResponsData?.totalContactsCount}</span> contacts are deleted successfully
                        </div>
                        {props.GroupDeletionResponsData?.deletedContactsCount !== props.GroupDeletionResponsData?.totalContactsCount && <>
                            <div className='h4-regular mt-1'>
                                {appNote.NOTE_FOR_NOT_DELETED_CONTACTS.replace('<GroupName>', props.DeletedGroupName)}
                            </div>
                            <GroupDeletionInfoComponent />
                        </>}
                    </>
                }
            </DialogContent>
            <DialogActions className="pb-2">
                {props.ResponsRecived ?
                    <ButtonComponent buttonProps={{ autoFocus: !props.ButtonName }} OnClick={(e) => { handleClose(e); setIsChecked(false) }} ButtonLabel={"Ok"} ClassName={"c-pointer mr-2"} Variant={"secondary-btn-small"} />
                    : <>
                        {!!props.ButtonName &&
                            <ButtonComponent OnClick={(e) => { props.onClose(true, e); !!props.HandleCheckbox && props.HandleCheckbox(false) }} ButtonLabel={props.ButtonName} ClassName={"c-pointer mr-2"} Variant={"primary-btn-small"} Loading={props.Loading} />
                        }
                        {!props.HideCancel &&
                            <ButtonComponent buttonProps={{ autoFocus: !props.ButtonName }} OnClick={(e) => { handleClose(e) }} ButtonLabel={buttonLabels.CANCEL} ClassName={"c-pointer mr-2"} Variant={"secondary-btn-small"} />
                        }

                    </>}
            </DialogActions>
        </Dialog >
    );
}

export default Confirm_Dialog;